import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore(
  'userStore', 
  () => {
    const user = ref(null)
    const token = ref(null)

    const isLoggedIn = () => {
      return user.value !== null && token.value !== null
    }

    const setUser = (data) => {
      user.value = data
    }

    const setToken = (data) => {
      token.value = data
    }

    const logout = () => {
      user.value = null
      token.value = null
    }

    return {
      user,
      token,
      setUser,
      setToken,
      logout,
      isLoggedIn
    }
  },
  {
    persist : true,
    paths : [
        'user',
        'token'
    ]
  }
)